import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  Menu,
  MenuItem,
  useTheme,
  Button,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  AccountCircle as AccountIcon,
  Search as SearchIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
import {
  CloudUpload as CloudUploadIcon,
  Person as PersonIcon,
  Home as HomeIcon,
  People as PeopleIcon,
  Add as AddIcon,
  Person as PersonIcon2,
  Badge as BadgeIcon,
} from "@mui/icons-material";
import { motion } from "motion/react";
import { useUser } from "../context/UserConext";
import MultiSelect from "./MultiSelect";
import { societyService } from "../services/society/societyService";
import { userService } from "../services/user/userService";
import ChangeCompanyModal from "./ChangeCompanyModal";
import { CompanyClientResponse } from "../types/api.types";
import { dispatchCompanyChanged } from "../utils/constants";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [notificationAnchor, setNotificationAnchor] =
    React.useState<null | HTMLElement>(null);

  const { user, logout } = useUser();

  const [showModal, setShowModal] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<CompanyClientResponse[]>(
    [],
  );

  const [selectedCompany, setSelectedCompany] = useState<any>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setNotificationAnchor(null);
  };

  const onGetCompanies = async () => {
    const response = await userService.getCompanies();
    setCompanyOptions(response);
  };

  useEffect(() => {
    onGetCompanies();
  }, []);

  useEffect(() => {
    setSelectedCompany(
      JSON.parse(
        localStorage.getItem("company") || "{}",
      ) as CompanyClientResponse,
    );
  }, []);

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: "transparent",
        backdropFilter: "blur(10px)",
        borderBottom: "none",
        boxShadow: "none",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          // padding: { xs: 1, sm: 2 },
          minHeight: "64px !important",
        }}
      >
        {/* Center - Search Bar (Hidden on mobile) */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            flex: 1,
            maxWidth: 400,
            mx: 4,
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ width: "100%" }}
          >
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: 2,
                padding: "8px 16px",
                width: "100%",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                "&:focus-within": {
                  border: `1px solid ${theme.palette.primary.main}`,
                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                },
              }}
            >
              <SearchIcon
                sx={{
                  color: theme.palette.primary.main,
                  mr: 1,
                  fontSize: 20,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  fontStyle: "italic",
                }}
              >
                Buscar...
              </Typography>
            </Box> */}
          </motion.div>
        </Box>

        {/* Right Side - Actions */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {user?.user?.rol === "Client" && (
            <>
              {/* Notifications */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.main,
                      marginRight: 2,
                    }}
                  >
                    {selectedCompany?.comercialName || ""}
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    Cambiar
                  </Button>
                </Box>
              </motion.div>
            </>
          )}

          {/* Profile Menu */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls="profile-menu"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              sx={{
                color: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  backgroundColor: theme.palette.primary.main,
                  fontSize: "0.875rem",
                }}
              >
                {(user?.user as any)?.email?.charAt(0)}
              </Avatar>
            </IconButton>
          </motion.div>
        </Box>

        {/* Profile Menu */}
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
              borderRadius: 2,
              border: "1px solid rgba(0, 0, 0, 0.1)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              width: 200,
            },
          }}
        >
          {/* <MenuItem onClick={handleMenuClose}>Perfil</MenuItem>
          <MenuItem onClick={handleMenuClose}>Configuración</MenuItem> */}
          <MenuItem
            onClick={() => {
              navigate("/change-password");
            }}
          >
            Cambiar contraseña
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleMenuClose();
              logout();
            }}
          >
            Cerrar Sesión
          </MenuItem>
        </Menu>

        {/* Notification Menu */}
        <Menu
          id="notification-menu"
          anchorEl={notificationAnchor}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(notificationAnchor)}
          onClose={handleMenuClose}
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
              borderRadius: 2,
              border: "1px solid rgba(0, 0, 0, 0.1)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              minWidth: 280,
            },
          }}
        >
          <MenuItem onClick={handleMenuClose}>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Nuevo pedido recibido
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Hace 5 minutos
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Inventario bajo en stock
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Hace 1 hora
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Usuario nuevo registrado
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Hace 2 horas
              </Typography>
            </Box>
          </MenuItem>
        </Menu>
      </Toolbar>
      <ChangeCompanyModal
        showModal={showModal}
        setShowModal={setShowModal}
        companyOptions={companyOptions}
        onSubmitProp={(data) => {
          const company = companyOptions.find(
            (company) => company.clientID === data.company,
          );
          setSelectedCompany(company);
          localStorage.setItem("company", JSON.stringify(company));
          dispatchCompanyChanged();
        }}
        selectedCompany={selectedCompany}
      />
    </AppBar>
  );
};

export default Header;
